import { Text } from 'components/Elements';
import React from 'react';

export const InfoPair = ({ label, value }) => (
  <div className="flex flex-col space-y-1">
    <span className="text-xs text-gray-200/80 tracking-wide uppercase font-medium drop-shadow-sm">
      {label}
    </span>
    <Text variant="base" className="text-gray-50 font-semibold drop-shadow-sm">
      {value}
    </Text>
  </div>
);
